module.exports = __webpack_public_path__ + "media/luxury-2026/glassy-kitchen-0284d5ef.jpg";